<script setup>
import { onMounted, onUpdated, defineProps } from "vue"
import { ref } from "@vue/reactivity"
import { KNOLIA } from "@/knolia"
import { Gems } from "@/gems"
import RatingSkills from "@/components/RatingSkills.vue"
import router from "@/router"
import ValidateSkills from "@/components/ValidateSkills.vue"
import RatingSkillsModal from "@/components/RatingSkillsModal.vue"
import { useRatingSkillsModalStore } from "../store/modules/rating-skills-modal"
import { useValidateSkills } from "@/composables/useValidateSkills"
import { useRatingSkills } from "@/composables/useRatingSkills"
import { MESSAGES } from "../messages"

const validateSkillsView = ref(false)
const refreshList = ref(false)
const ratingSkillsModal = useRatingSkillsModalStore()
const isLowerThanMobile = ref(KNOLIA.updateIsLowerThanMobile())
const isMobile = ref(KNOLIA.updateIsMobile())
const validate = useValidateSkills()
const rating = useRatingSkills()

const props = defineProps({
  userStore: {
    type: Object,
    default: Object
  }
})

async function SetValidation(elem) {
  const response = KNOLIA.CallBackEnd("post", "control-rating-skills", { elem, type: 'set-validation' })

  if(response.error) {
    Gems.Telegram(MESSAGES.ERROR.DEFAULT, 'tele-not-allowed')
    return
  }
}

function CommentsRead(params) {
  if(validateSkillsView.value)
    validate.SetCommentsRead(params.skills_ratings_id, params.only_validators)
  else
    rating.SetCommentsRead(params.skills_ratings_id, params.only_validators)
}

function SetDocumentsRead(params) {
  if(validateSkillsView.value)
    validate.SetDocumentsRead(params.skills_ratings_id)
}

onMounted(() => {
  validateSkillsView.value = router.currentRoute.value.params.validateSkills
});

onUpdated(() => {
  validateSkillsView.value = router.currentRoute.value.params.validateSkills
});
</script>

<template>
  <div :class="{'page-container': !validateSkillsView}" v-if="validate !== null || rating !== null">
    <component
      :is="validateSkillsView ? ValidateSkills : RatingSkills"
      :refresh="refreshList"
      :rating-skills-modal="ratingSkillsModal"
      :is-lower-than-mobile="isLowerThanMobile"
      :is-mobile="isMobile"
      :validate="validate"
      :rating="rating"
      @update-filter-by-job="rating.filterByJob.value = $event"
      @update-selected-ddl="rating.selectedDDL.value = JSON.parse($event)"
      @update-rank-type="rating.rankType.value = $event"
      :user-store="props.userStore"
    />
    
    <RatingSkillsModal v-if="ratingSkillsModal.ShowModal" class="modal-component" :element="ratingSkillsModal.Element" :show-chat="showChat"
      :validate-skills="validateSkillsView" @set-validation="SetValidation($event)" @comments-read="CommentsRead($event)" @documents-read="SetDocumentsRead($event)"
      :rating-skills-modal="ratingSkillsModal" @refresh-list="refreshList = $event" :rating-store="rating" 
    />
  </div>
</template>

<style scoped></style>
